import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/locationgcc/dubai_new/banner_dubai.webp";
import Bannerfrom from "../components/bannerfrom";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner android_banner no-bread-banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 style={{ color: "#fff" }}>
                Custom Mobile App Development Company in Dubai
              </h1>
              <p>
                TekRevol is UAE’s leading custom mobile app development company
                based in Dubai for business-specific, high-performance iOS,
                Android, and Cross-Platform applications. Along with bagging
                global recognition, our skilled mobile app developers in Dubai
                are known for leveraging modern technologies, proven development
                frameworks, and growth-driven adaption strategy to build
                user-friendly mobile app for startups, mid-level businesses, and
                established enterprises.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Discuss Your App Idea
              </Link>
            </div>
          </Col>
          <Col xs={12} md={5} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
